import React from "react";

interface CardGradientProps {
  className?: string;
  width?: string | number;
  height?: string | number;
}

const ChevronBack: React.FC<CardGradientProps> = ({
  className,
  width = "17",
  height = "17",
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1490_15697"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="17"
        height="17"
      >
        <rect
          x="16.5"
          y="16.5"
          width="16"
          height="16"
          transform="rotate(-180 16.5 16.5)"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_1490_15697)">
        <path
          d="M6.85001 8.50016L11.75 13.4002C11.9167 13.5668 11.9972 13.7641 11.9917 13.9918C11.9861 14.2196 11.9 14.4168 11.7333 14.5835C11.5667 14.7502 11.3695 14.8335 11.1417 14.8335C10.9139 14.8335 10.7167 14.7502 10.55 14.5835L5.43334 9.45016C5.30001 9.31683 5.20001 9.16683 5.13334 9.00016C5.06667 8.83349 5.03334 8.66683 5.03334 8.50016C5.03334 8.33349 5.06667 8.16683 5.13334 8.00016C5.20001 7.83349 5.30001 7.68349 5.43334 7.55016L10.5667 2.41683C10.7333 2.25016 10.9278 2.1696 11.15 2.17516C11.3722 2.18071 11.5667 2.26683 11.7333 2.43349C11.9 2.60016 11.9833 2.79738 11.9833 3.02516C11.9833 3.25294 11.9 3.45016 11.7333 3.61683L6.85001 8.50016Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export default ChevronBack;
